import { render, staticRenderFns } from "./WebSettingsAction.vue?vue&type=template&id=584aec0e&scoped=true"
import script from "./WebSettingsAction.vue?vue&type=script&lang=js"
export * from "./WebSettingsAction.vue?vue&type=script&lang=js"
import style0 from "./WebSettingsAction.vue?vue&type=style&index=0&id=584aec0e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584aec0e",
  null
  
)

export default component.exports